export function setChildInfoData(state, payload) {
  return { 
    ...state,
    childInfo: {
      ...state.childInfo,
      data: payload
    }
  };
}

export function setChildInfoStatus(state, status) {
  return {
    ...state,
    childInfo: {
      ...state.childInfo,
      status: status
    }
  };
}

export function removeChildMedia(state) {
  return {
    ...state,
    childInfo: {
      ...(state.childInfo || {}),
      data: {
        ...(state.childInfo.data || {}),
        childMedia: [],
      },
    },
  };
}